import { render, staticRenderFns } from "./consent-apex-chart-card.vue?vue&type=template&id=1282a834&"
import script from "./consent-apex-chart-card.vue?vue&type=script&lang=js&"
export * from "./consent-apex-chart-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "consent-apex-chart-card.vue"
export default component.exports